import { useTranslate } from "@tolgee/react";
import { usePortfolioChart } from "../hooks/use-portfolio-chart";
import { PortfolioChartArea } from "./portfolio-chart-area";
import { PortfolioChartFilterBar } from "./portfolio-chart-filter-bar";
import { PortfolioChartHeader } from "./portfolio-chart-header";

export function PortfolioChart() {
	const { t } = useTranslate();
	const view = usePortfolioChart();

	return (
		<div>
			<PortfolioChartFilterBar
				filters={view.filters}
				options={view.options}
			/>

			<PortfolioChartHeader
				volume={view.volume}
				rightLabel={view.headerRightLabel}
				currentValue={view.currentValue}
				currentColor={view.currentColor}
				metric={view.filters.metric}
			/>

			<div className="mt-3 h-[260px] w-full">
				{view.isLoading ? (
					<div className="flex h-full w-full items-center justify-center text-label2 text-muted-foreground">
						{t("portfolio.chart.loading")}
					</div>
				) : view.series.length === 0 ? (
					<div className="flex h-full w-full items-center justify-center text-label2 text-muted-foreground">
						{t("portfolio.chart.empty")}
					</div>
				) : (
					<PortfolioChartArea
						series={view.series}
						max={view.max}
						min={view.min}
						timeRange={view.filters.timeRange}
						metric={view.filters.metric}
						metricLabel={view.metricLabel}
						gradientOffset={view.gradientOffset}
					/>
				)}
			</div>
		</div>
	);
}
